export function slugify(str, sep = "_") {
  // Source: https://gist.github.com/mathewbyrne/1280286
  str = str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/-,:;";
  var to = "aaaaeeeeiiiioooouuuunc______";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }
  str = str
    .replace(/[^a-z0-9_ ]/g, "") // remove invalid chars
    .replace(/\s+/g, sep); // collapse whitespaces and replace with _
  return str;
}

export function removeJsonApiMeta(response) {
  const data = { ...response, _jv: undefined };
  delete data._jv;
  return data;
}

export function arrayUnique(array) {
  let a = array.concat();
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i].identifier === a[j].identifier) a.splice(j--, 1);
    }
  }
  return a;
}

export function pluralize(word, count = 2) {
  // default of count set to 2 to automatically pluralize.
  // obviously this function should be carefully used as it is a dummy suffixer,
  // which fits current use cases.
  // Nonetheless, this function can be changed to support more cases, for example:
  // https://github.com/blakeembrey/pluralize
  // https://stackoverflow.com/questions/27194359/javascript-pluralize-an-english-string
  if (Math.abs(count) <= 1) {
    return word;
  } else {
    if (word.endsWith("s")) return `${word}es`;
    else return `${word}s`;
  }
}

export function capitalize(value) {
  if (!value) {
    return "";
  }
  return (
    value
      .toString()
      .charAt(0)
      .toUpperCase() + value.slice(1)
  );
}

export function randomAdjective() {
  const adjectives = ["impressive", "beautiful", "elaborate", "extravagant", "striking"];
  return adjectives[Math.floor(Math.random() * adjectives.length)];
}
